import { useCourses } from 'querys/course'
import styled from 'styled-components'
import OnDeploy from 'common/on-deploy'
import CourseCard from './card'

const CourseListStyled = styled.ul`
  padding: 16px 0;
  @media(min-width: 768px) {
    padding: 0;
    margin-top: 24px;
  }
`

function CourseList() {
  const { data, error } = useCourses()

  if (error?.message === 'Deploy') return <OnDeploy />

  if (!data?.length) return null

  return (
    <CourseListStyled>
      {data.map((course) => <CourseCard key={course.slug} course={course} />)}
    </CourseListStyled>
  )
}

export default CourseList
